const DEVICE_ID_STORAGE_KEY = 'dooh_deviceId';
const HARDWARE_SERIAL_PARAM = 'hardwareSerial';
const HARDWARE_SERIAL_REGEX = /^[0-9A-F]{8,}$/;
const DEVICE_ID_REGEX = /^TS_[0-9A-F]{8}$/;

interface DeviceIdStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function deriveDeviceIdFromHardwareSerial(hardwareSerial: string): string {
  const normalized = hardwareSerial.trim().toUpperCase();
  if (!HARDWARE_SERIAL_REGEX.test(normalized)) {
    throw new Error('A valid hexadecimal Raspberry Pi hardware serial is required');
  }
  return `TS_${normalized.slice(-8)}`;
}

export function resolveDeviceId(search: string, storage: DeviceIdStorage): string {
  const hardwareSerial = new URLSearchParams(search).get(HARDWARE_SERIAL_PARAM);
  if (hardwareSerial) {
    const deviceId = deriveDeviceIdFromHardwareSerial(hardwareSerial);
    storage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    return deviceId;
  }

  const stored = storage.getItem(DEVICE_ID_STORAGE_KEY);
  if (stored && DEVICE_ID_REGEX.test(stored)) return stored;

  throw new Error('Raspberry Pi hardware serial is missing from the player URL');
}
